var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex align-center",on:{"click":function($event){$event.preventDefault();return _vm.toggleChecked.apply(null, arguments)}}},[(_vm.label)?_c('label',{staticClass:"font-label mr-8"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('div',{staticClass:"checkbox__checkmark",class:{
        'checkbox__checkmark--checked': _vm.checked,
        'checkbox__checkmark--disabled': _vm.disabled,
      }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }